import { Input, Component } from '@angular/core';
import { Person } from '../../core-data-model/Person.model';
import { SearchResult } from '../../core-data-model/SearchResult.model';

@Component({
    selector: 'job-link',
    template: `
        @if (displayString !== undefined && displayString !== null) {
            <a class="lsg-link" [routerLink]="url">
                {{ displayString }}
            </a>
        }
    `,
    standalone: false
})
export class NewTableJobLinkComponent {
    @Input()
    result: SearchResult;

    get displayString() {
        return this.result instanceof Person && this.result.job
            ? this.result.job.title || ''
            : '';
    }

    get url(): string {
        return this.result instanceof Person && this.result.job
            ? `/job/${this.result.job.id}`
            : '';
    }
}
